'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function LTFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-bauui7xqc", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-d57bhscbd", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-y1l4120oh" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-y1l4120oh", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-bauui7xqc)" }, /* @__PURE__ */ React.createElement("use", { fill: "#55ba07", xlinkHref: "#mantine-y1l4120oh" }), /* @__PURE__ */ React.createElement("path", { fill: "#feca00", d: "M0 0h32v8H0z", mask: "url(#mantine-d57bhscbd)" }), /* @__PURE__ */ React.createElement("path", { fill: "#c51918", d: "M0 16h32v8H0z", mask: "url(#mantine-d57bhscbd)" })))
  );
}

export { LTFlag };
//# sourceMappingURL=LT.mjs.map
